import { inject } from "vue";
import { useUrlSearchParams } from "@vueuse/core";

const urlSearchParamsKey = Symbol("urlSearchParamsKey");

export const AppUrlSearchParams = {
  install(app, options) {
    const urlSearchParams = useUrlSearchParams("history");
    app.provide(urlSearchParamsKey, urlSearchParams);
  },
};

export const useAppUrlSearchParams = () => {
  const AppUrlSearchParams = inject(urlSearchParamsKey);
  if (!AppUrlSearchParams) {
    throw new Error("No App UrlSearchParams provided!");
  }
  return AppUrlSearchParams;
};
